export interface Puzzle {
  id: string;
  name: string;
  nameUa: string;
  description: string;
  descriptionUa: string;
  size: number;
  solution: boolean[][];
  difficulty: 'easy' | 'medium' | 'hard';
  category: 'national' | 'nature' | 'religious' | 'mythological' | 'geometric';
}

export const puzzles: Puzzle[] = [
  // Easy 5x5
  {
    id: 'tryzub',
    name: 'Tryzub',
    nameUa: 'Тризуб',
    description: 'The Tryzub is the national coat of arms of Ukraine.',
    descriptionUa: 'Тризуб — державний символ України.',
    size: 5,
    difficulty: 'easy',
    category: 'national',
    solution: [
      [false, true, true, true, false],
      [false, true, true, true, false],
      [false, false, true, false, false],
      [false, true, false, true, false],
      [false, true, false, true, false]
    ]
  },
  {
    id: 'rozeta',
    name: 'Rozeta',
    nameUa: 'Розета',
    description: 'Traditional Ukrainian ceramic pattern.',
    descriptionUa: 'Традиційний український керамічний візерунок.',
    size: 5,
    difficulty: 'easy',
    category: 'geometric',
    solution: [
      [false, true, true, true, false],
      [true, true, true, true, true],
      [true, true, true, true, true],
      [true, true, true, true, true],
      [false, true, true, true, false]
    ]
  },
  {
    id: 'serce',
    name: 'Serce',
    nameUa: 'Серце',
    description: 'Love for homeland is in every Ukrainian\'s heart.',
    descriptionUa: 'Любов до Батьківщини у серці кожного Українця.',
    size: 5,
    difficulty: 'easy',
    category: 'national',
    solution: [
      [false, true, false, true, false],
      [true, true, true, true, true],
      [true, true, true, true, true],
      [false, true, true, true, false],
      [false, false, true, false, false]
    ]
  },
  // Medium 10x10
  {
    id: 'kalyna',
    name: 'Kalyna',
    nameUa: 'Калина',
    description: 'The holy tree of Ukraine, symbol of beauty and strength.',
    descriptionUa: 'Калина — священне дерево України, символ краси та сили.',
    size: 10,
    difficulty: 'medium',
    category: 'nature',
    solution: [
      [false, false, true, false, false, false, false, true, false, false],
      [false, true, true, true, false, false, true, true, true, false],
      [true, true, true, true, true, true, true, true, true, true],
      [false, true, true, true, false, false, true, true, true, false],
      [false, false, true, false, false, false, false, true, false, false],
      [false, false, false, false, true, true, false, false, false, false],
      [false, false, false, true, true, true, false, false, false, false],
      [false, false, true, true, false, false, true, true, false, false],
      [false, true, true, false, false, false, false, true, true, false],
      [true, false, false, false, false, false, false, false, false, true]
    ]
  },
  // Hard 15x15
  {
    id: 'dub',
    name: 'Dub',
    nameUa: 'Дуб',
    description: 'The oak is a sacred tree in Ukrainian folklore.',
    descriptionUa: 'Дуб — священне дерево в українському фольклорі.',
    size: 15,
    difficulty: 'hard',
    category: 'nature',
    solution: [
      [false, false, false, true, false, false, false, false, true, false, false, false, false, false, false],
      [false, false, true, true, true, false, false, true, true, true, false, false, false, false, false],
      [false, true, true, true, true, true, false, true, true, true, true, false, false, false, false],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, false],
      [false, false, true, true, true, true, true, true, true, true, true, false, false, false, false],
      [false, false, false, true, true, true, true, true, true, true, false, false, false, false, false],
      [false, false, false, false, true, true, true, true, false, false, false, false, false, false, false],
      [false, false, false, false, false, true, true, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, true, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, true, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, true, true, false, false, false, false, false, false, false, false],
      [false, false, false, false, true, true, true, true, false, false, false, false, false, false, false],
      [false, false, false, true, true, true, true, true, true, true, false, false, false, false, false],
      [false, false, true, true, true, true, true, true, true, true, true, false, false, false, false],
      [false, true, true, true, true, true, true, true, true, true, true, true, true, true, false]
    ]
  }
];

export const difficulties = ['easy', 'medium', 'hard'] as const;
